<template>
  <div class="w-full text-sm leading-relaxed text-center">
    <h1 class="text-xl font-bold">You're all done!</h1>
    <br />
    <p>We have sent you an e-mail with a link.</p>
    <p>Please click on that link to access the claim form.</p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ConfirmationMessage',
  computed: {
    ...mapState({
      email: (state) => state.email
    })
  }
};
</script>
